import {
	AppointmentBlocksTypes,
	AppointmentBlockType,
	AppointmentType,
	AppointmentTypes,
} from "../../models/entities/appointments.model";
import { Formatter } from "../formatter/formatter.service";

// Date: today's date
const getTodayDate = () => {
	const today: Date = new Date();
	today.setHours(0, 0, 0, 0);
	return today;
};

// Table template: datetime
const templateDatetime = (dateOn: string, format: Intl.DateTimeFormatOptions) =>
	Formatter.dateISOToString(dateOn, format);

// Table template: duration
const templateDuration = (
	type: AppointmentType,
	appointmentTypes: AppointmentTypes[],
	showPadding: boolean
) => {
	const appointment = appointmentTypes.find((x) => x.type === type);
	let result = `${appointment?.durationInMinutes ?? Formatter.NO_DATA} min`;
	if (showPadding) {
		result += ` + ${appointment?.totalPaddingInMinutes ?? Formatter.NO_DATA} buffer`;
	}
	return result;
};

const formatTypeDuration = (type: string) => {
	let result = "";
	switch (type) {
		case AppointmentType.COACHING_CALL_10:
			result = " (10 min)";
			break;
		case AppointmentType.COACHING_CALL_15:
			result = " (15 min)";
			break;
		case AppointmentType.COACHING_CALL_30:
			result = " (30 min)";
			break;
		case AppointmentType.COACHING_CALL_45:
			result = " (45 min)";
			break;
		case AppointmentType.KANNACT_INTRO_CALL_10:
			result = " (10 min)";
			break;
		default:
			break;
	}
	return result;
};

const isPast = (
	datetime: string,
	type: AppointmentType | AppointmentBlockType,
	appointmentTypes: AppointmentTypes[],
	appointmentBlocksTypes: AppointmentBlocksTypes[]
) => {
	// Duration + Buffer
	const appt = type.includes("_BLOCK")
		? appointmentBlocksTypes.find((x) => x.type === type)
		: appointmentTypes.find((x) => x.type === type);
	const total = (appt?.durationInMinutes || 0) + (appt?.totalPaddingInMinutes || 0);

	const now = new Date();

	const apptDate = new Date(datetime);
	apptDate.setMinutes(apptDate.getMinutes() + total);

	return now.getTime() > apptDate.getTime();
};

export const AppointmentsService = {
	getTodayDate,
	formatTypeDuration,
	templateDatetime,
	templateDuration,
	isPast,
};
